import { Tooltip } from '@mui/material';
import React from 'react';
import { formatDate, formatTime } from '../utils';

const FormattedDateTimeTooltip = ({ date }: { date?: string|null }) => {
	if (!date) return <>-</>;
	return (
		<Tooltip title={formatTime(date)}>
			<span>{formatDate(date)}</span>
		</Tooltip>
	);
};

export default FormattedDateTimeTooltip;
